import { TransferJobTaskStatus } from '@frameio/graphql-client/client-schema/transfers/state/transferJobTaskStatus';

/**
 * @todo (Assets-543): Remove all types here and leverage
 * the graphQL schema for TransferItem.
 */
export type uploadType = 'FILE' | 'FOLDER';

/**
 * @todo (Assets-543): Remove all types here and leverage
 * the graphQL schema for TransferItem.
 */
type AbstractUploadItem = {
  /**
   * Reference to the temp parent id before the real item is created.
   * If this uploadItem is an asset, this will become its parent folder's id.
   */
  readonly tempParentId: string | null;

  /** @note: are we still even using this with the new share model? */
  readonly sortIndex: number;

  /** File/Asset name */
  readonly name: string;

  /**
   * Real uuid that gets set later after the real item is created.
   * If this uploadItem is an asset, this will become its assetId.
   * If this uploadItem is an attachment, this will become its attachmentId.
   */
  destinationId?: string;
};

/**
 * @todo (Assets-543): Remove all types here and leverage
 * the graphQL schema for TransferItem.
 */
export type UploadFileItem = {
  readonly type: 'FILE';
  readonly file?: File;
  status: TransferJobTaskStatus;
  clientXxh64?: string;
  serverXxh64?: string;
} & AbstractUploadItem;

/**
 * @todo (Assets-543): Remove all types here and leverage
 * the graphQL schema for TransferItem.
 */
export type UploadFolderItem = {
  readonly type: 'FOLDER';
  readonly tempId: string;
  readonly pathArray: string[];
} & AbstractUploadItem;

/**
 * @todo (Assets-543): Remove all types here and leverage
 * the graphQL schema for TransferItem.
 */
export type UploadItem = UploadFileItem | UploadFolderItem;

/**
 * Create a folder item for a folder tree.
 *
 * @param {string} parentFolderId  - Parent folder id.
 * @param {string} name - Folder name.
 * @param {number} index - Custom sort index.
 * @returns {Object} - Folder item.
 */
export function createFolderItem(
  tempParentId: string | null,
  name: string,
  index: number,
  pathArray: string[]
): UploadFolderItem {
  return {
    tempId: crypto.randomUUID(),
    sortIndex: index,
    name,
    tempParentId,
    type: 'FOLDER',
    pathArray,
  };
}

/**
 * Create a file item for a folder tree.
 *
 * @param {string} tempParentId  - Parentid, for an asset this is its parent folder
 * @param {File} file - File object.
 * @param {number} index - Custom sort index.
 * @returns {Object} - File item.
 */
export function createFileItem(
  tempParentId: string | null,
  file: File,
  index: number
): UploadFileItem {
  /*
   * @note: should expose the full path from the items to
   * enable the resumable upload manifest
   */
  return {
    file,
    sortIndex: index,
    name: file.name,
    status: TransferJobTaskStatus.IDLE,
    tempParentId,
    type: 'FILE',
  };
}
